import { makeHttpRequest } from "@/shared";

export const deleteSourcesAttraction = async (ids) => {
    return (
        await makeHttpRequest({
            url: "/attraction/delete-multiple",
            method: "DELETE",
            params: { items: ids },
        })
    ).data;
};
